import { c as _c } from "react/compiler-runtime";
import GridRow from "@/components/common/grid-row/grid-row";
import ProductCard from "./product-card/product-card";
import GridColumn from "@/components/common/grid-column/grid-column";
import SuperTitle from "@/components/common/supertitle/supertitle";
import Card, { CardStyle } from "@/components/common/card/card";
import { IconBenefits, PortableText } from "@/sanity/sanity.types";
import imageUrl from "@/sanity/utilities/imageUrl";
interface IProductCardsProps {
  data: IconBenefits;
}
const ProductCards = props => {
  const $ = _c(8);
  const {
    data
  } = props;
  const {
    items
  } = data;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SuperTitle>KEY BENEFITS</SuperTitle>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== data.heading) {
    t1 = <GridColumn><div className="flex flex-col items-start gap-6 lg:items-center">{t0}<h2>{data.heading}</h2></div></GridColumn>;
    $[1] = data.heading;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== items) {
    t2 = items?.map(_temp);
    $[3] = items;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <GridRow className="!gap-6">{t1}{t2}</GridRow>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default ProductCards;
function _temp(item, index) {
  return <GridColumn lg={6} key={index}><Card title={item.title ?? ""} description={item?.body as PortableText | undefined} imgUrl={item.icon?.asset ? imageUrl(item.icon.asset).height(41).url() : undefined} style={CardStyle.Secondary} imgWidth={40} imgHeight={41} /></GridColumn>;
}